import { EQpQuestionType } from '@library/models/qp-question.models';
import { EYesNoNa } from '@one/app/pages/isp/pages/inspection/pages/id/pages/categories/pages/id/pages/test/pages/id/components/tests-checklist-element/tests-checklist-element-yes-no/models/isp-inspection-id-categories-id-test-id-yes-no-na.models';
import { YesNoAnswerModel } from '@one/app/shared/classes/answer/yes-no-answer';
import { Answer } from '@one/app/shared/models/answer/answer.models';

function parseAutoFillValue(questionType: EQpQuestionType, fillValue: string): Answer | null {
  const trimmed = fillValue.trim();

  switch (questionType) {
    case EQpQuestionType.YES_NO:
      return YesNoAnswerModel.create(parseYesNoValue(trimmed), null);
    case EQpQuestionType.YES_NO_NA:
      return YesNoAnswerModel.create(parseYesNoNaValue(trimmed), null);
    case EQpQuestionType.MULTIPLE_CHOICE:
      return [trimmed];
    case EQpQuestionType.NUMBER:
    case EQpQuestionType.AVERAGE_NUMBER: {
      const numeric = Number(trimmed);

      return Number.isFinite(numeric) ? numeric : null;
    }

    case EQpQuestionType.TEXT:
    default:
      return trimmed;
  }
}

function parseYesNoValue(fillValue: string): boolean | null {
  if (fillValue.localeCompare('yes', undefined, { sensitivity: 'accent' }) === 0 || fillValue === 'true') {
    return true;
  }

  if (fillValue.localeCompare('no', undefined, { sensitivity: 'accent' }) === 0 || fillValue === 'false') {
    return false;
  }

  return null;
}

function parseYesNoNaValue(fillValue: string): EYesNoNa | null {
  const normalized = fillValue.toUpperCase();

  if (normalized === EYesNoNa.YES) {
    return EYesNoNa.YES;
  }

  if (normalized === EYesNoNa.NO) {
    return EYesNoNa.NO;
  }

  if (normalized === EYesNoNa.NA) {
    return EYesNoNa.NA;
  }

  return parseYesNoValue(fillValue) === true ? EYesNoNa.YES : parseYesNoValue(fillValue) === false ? EYesNoNa.NO : null;
}

export { parseAutoFillValue };
